import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Supplier } from '../state/types'

export const useSupplierLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllSuppliers = (active = false) => getList(TableName.SUPPLIERS, active) as Supplier[]
        
        const loadAllSuppliers = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.SUPPLIERS, options)
            return response.dataTypes as Supplier[]
        }

        const loadSupplier = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.SUPPLIERS, id, dbRequest) as Promise<O<Supplier>>
        }
        
        const loadSuppliers = (ids: string[]) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.SUPPLIERS, ids) as Promise<Supplier[]>
        }

        const loadTypeSuppliers = (productSupplier: boolean, dbRequest = false) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.SUPPLIERS, dbRequest, { productSupplier }) as Promise<Supplier[]>
        }

        return {
            findAllSuppliers,
            loadAllSuppliers,
            loadSupplier,
            loadSuppliers,
            loadTypeSuppliers
        }
    }
}
